import { createAction, props } from '@ngrx/store';
import { SimXReleaseTag } from '../../../shared/models/entities/simx-release-tag.model';

export enum ActionTypes {
  RequestReleaseTags = '[Release Tag] Request Release Tags',
  FetchReleaseTags = '[Release Tag] Fetch Release Tags',
  FetchReleaseTagsSucceeded = '[Release Tag] Fetch Release Tags Succeeded',
  FetchReleaseTagsFailed = '[Release Tag] Fetch Release Tags Failed',
  ResetReleaseTagStore = '[Release Tag] Reset Release Tag Store',
}

export const requestReleaseTags = createAction(ActionTypes.RequestReleaseTags);
export const fetchReleaseTags = createAction(ActionTypes.FetchReleaseTags);
export const fetchReleaseTagsSucceeded = createAction(
  ActionTypes.FetchReleaseTagsSucceeded,
  props<{ releaseTags: Array<SimXReleaseTag> }>(),
);
export const fetchReleaseTagsFailed = createAction(
  ActionTypes.FetchReleaseTagsFailed,
);
export const resetReleaseTagStore = createAction(
  ActionTypes.ResetReleaseTagStore,
);
